var map = {
	"./fail-icon.png": "14ec",
	"./image-not-found.png": "cbd0",
	"./logo.png": "cf05",
	"./payment/thai_qr.png": "4c5e",
	"./payment/wallet-logo.png": "fedc",
	"./payment/wechat-pay.png": "06a2",
	"./payment/wechat-payment-white.png": "81fa",
	"./search.png": "bbc5",
	"./success-icon-blue.png": "356c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";